import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getLabelMessage } from '@gef-ui/localization/messages';

import SettingsSubSwitch from 'pages/Settings/components/NotificationSending/SettingsSubSwitch';

import ToggleAllButtons from './ToggleAllButtons';

export const TasksSettings = ({ tasks = [] }) => {
	return (
		<Stack>
			<Stack
				direction="row"
				sx={{
					justifyContent: 'space-between',
				}}
			>
				<Typography variant="h5" color="text.primary">
					{getLabelMessage('settings:tasks')}
				</Typography>
				<ToggleAllButtons items={tasks} />
			</Stack>
			<Grid container>
				{tasks.map((filter) => (
					<Grid size={6}>
						<SettingsSubSwitch filter={filter} />
					</Grid>
				))}
			</Grid>
		</Stack>
	);
};

TasksSettings.propTypes = {
	tasks: PropTypes.array,
};

export default TasksSettings;
